// Fuente única de verdad para el SEO del sitio: la usan las páginas (vía
// setPageMeta, al navegar en el navegador) y scripts/prerender.mjs (al
// generar el HTML estático de cada ruta en el build). Si cambias un título o
// una descripción, cámbialo aquí y ambos quedan sincronizados.

export const SITE_URL = 'https://www.orbiax.co';
export const SITE_NAME = 'Orbiax';
export const OG_IMAGE = `${SITE_URL}/og-image.png`;

export const PAGES = {
  home: {
    path: '/',
    title: 'Orbiax | Automatización de procesos e IA para empresas',
    description:
      'Orbiax es una empresa colombiana de tecnología que automatiza procesos y despliega agentes de Inteligencia Artificial, aplicaciones web y móviles a la medida. Diagnóstico gratuito.',
    breadcrumb: 'Inicio',
    priority: '1.0',
  },
  services: {
    path: '/servicios',
    title: 'Agentes de IA, automatización y software a la medida | Orbiax',
    description:
      'Servicios de Orbiax: consultoría tecnológica, agentes de Inteligencia Artificial, automatización de procesos (RPA), integración de APIs, desarrollo de software a la medida y QA. Cualquier stack, cualquier nube.',
    breadcrumb: 'Servicios',
    priority: '0.9',
  },
  diagnostic: {
    path: '/diagnostico-gratuito',
    title: 'Diagnóstico gratuito de automatización e IA | Orbiax',
    description:
      'Solicita un diagnóstico gratuito de Orbiax: evaluamos tus flujos de trabajo y te mostramos qué procesos automatizar con Inteligencia Artificial para escalar tu operación.',
    breadcrumb: 'Diagnóstico gratuito',
    priority: '0.8',
  },
  contact: {
    path: '/contacto',
    title: 'Contacto | Orbiax, automatización e IA en Bogotá, Colombia',
    description:
      'Contacta a Orbiax en Bogotá, Colombia: agenda una consulta gratuita sobre automatización de procesos, agentes de IA y desarrollo de software. WhatsApp +57 322 857 1202.',
    breadcrumb: 'Contacto',
    priority: '0.8',
  },
};

// URLs viejas (en inglés) -> URLs nuevas. Se usan en Routes.jsx para
// redirigir en el navegador y en public/_redirects (301 en Cloudflare) para
// que Google traspase lo que ya tenían indexado.
export const LEGACY_REDIRECTS = {
  '/corporate-landing-page': PAGES.home.path,
  '/erp-solutions-showcase': PAGES.services.path,
  '/diagnostic-consultation-request': PAGES.diagnostic.path,
  '/contact-and-consultation-booking': PAGES.contact.path,
};

export const pageUrl = (path) => `${SITE_URL}${path === '/' ? '/' : path}`;
